export default __webpack_public_path__ + "static/media/mp4.f7ec4caa.svg";